import classNames from 'classnames'
import { aiPreCreate_pictureGraph_aiArtworkPayStrategyTips } from '~/graphqls/types'

interface Props {
  detail: aiPreCreate_pictureGraph_aiArtworkPayStrategyTips
}

export default function PreCreateDetail({ detail }: Props) {
  const {
    integralUseOnResolution = 0,
    integralUseOnAccelerate = 0,
    integralUseOnCreate = 0,
    discountIntegral = 0,
  } = detail.integralUse || {}
  const total =
    integralUseOnResolution +
    integralUseOnAccelerate +
    integralUseOnCreate -
    discountIntegral
  const { accelerateTimesUse = 0 } = detail.vipRightsUse || {}

  return (
    <div className="text-neutral-400 text-sm text-center">
      <>
        {[
          { label: '高分辨率尺寸', point: integralUseOnResolution },
          { label: '加速生成消耗', point: integralUseOnAccelerate },
          { label: '作画生成', point: integralUseOnCreate },
          { label: '潮汐模式生成优惠', point: -Number(discountIntegral) },
        ].map(item => {
          if (!item.point) {
            return null
          }
          return (
            <div
              className="flex items-center justify-between my-2"
              key={item.label}
            >
              <div className="text-neutral-500">{item.label}</div>
              <div
                className={classNames({
                  ['text-neutral-800']: item.point > 0,
                  ['text-[#23C562]']: item.point < 0,
                })}
              >
                {item.point > 0 && '-'}
                {Math.abs(item.point)}
                &nbsp;积分
              </div>
            </div>
          )
        })}
        <div className="flex items-center justify-between my-2">
          <div className="text-neutral-500">合计</div>
          <div className="text-[#EF466F]">-{total}&nbsp;积分</div>
        </div>
        <div className="w-full h-px bg-neutral-200 my-4"></div>
      </>

      {!!accelerateTimesUse && (
        <>
          <div className="text-neutral-800 font-semibold text-left">
            权益卡消耗
          </div>
          {[{ label: '加速次数', point: accelerateTimesUse, unit: '次' }].map(
            item => {
              if (!item.point) return null
              return (
                <div
                  className="flex items-center justify-between my-2"
                  key={item.label}
                >
                  <div className="text-neutral-500">{item.label}</div>
                  <div className="text-[#EF466F]">
                    -{item.point}&nbsp;{item.unit}
                  </div>
                </div>
              )
            }
          )}
        </>
      )}
    </div>
  )
}
